const state = {
  config: {
    project_id: null,
    solar_groups_visible: false,
    distances_visible: false,
    measurements_visible: false,
    // Deliberately absent from the vuex-persist reducer in store/index.js: it is
    // per-project server state, and a persisted copy would show the previous
    // project's AI damages until this project's config GET lands.
    damage_detection_mode_activated_at: null,
    // Whether the damage markers and the Damages section are shown. Markers
    // start hidden on a project that never switched them on, which is why the
    // default is false where the other visibility flags default to true. Kept
    // out of vuex-persist for the same reason as the activation date.
    annotations_visible: false,
  },
};

const mutations = {
  SET_CONFIG(state, config) {
    state.config = { ...state.config, ...config };
  },
};

const actions = {
  setConfig({ commit }, config) {
    commit("SET_CONFIG", config);
  },
};

const getters = {
  getConfig: (state) => state.config,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
